import { useState } from 'react';
import { TextField } from '@mui/material';
import CustomDialog from '../../../components/dialog/CustomDialog';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './UsernameToResetForm.scss';

const defaultProps = {
  onClose: () => { },
  openDialog: false,
  onSubmit: () => { },
  loading: false,
};

const UsernameToResetForm = (props) => {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { onClose, openDialog, onSubmit, loading } = mergedProps;
  const [value, setValue] = useState('');

  const handleOnTextChange = (e) => {
    setValue(e.target.value);
  };

  const handleOnKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      onSubmit(value);
    }
  };

  const handleOnNextClick = (e) => {
    e.preventDefault();
    onSubmit(value);
  };

  return (
    <CustomDialog
      className='username-to-reset-form-dialog'
      openDialog={openDialog}
      onClose={onClose}
      title={(
        <div className='title'>
          Reset Password
        </div>
      )}
      content={(
        <div className='content'>
          <TextField
            className='text-form'
            value={value}
            label='Please enter your username or email address'
            inputProps={{
              maxLength: 255,
              'data-private': 'redact',
            }}
            onKeyPress={handleOnKeyPress}
            onChange={handleOnTextChange}
          />
        </div>
      )}
      displayCloseIcon
      actions={[
        {
          title: 'Next',
          onClick: handleOnNextClick,
          className: 'btn-primary next-button',
          disabled: !value || value.length === 0,
          loading,
        },
      ]}
    />
  );
};

export default UsernameToResetForm;
